/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {CompoApiService} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {Executor} from './executor-autocomplete.store';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExecutorAutocompleteService {

  constructor(private readonly apiService: CompoApiService) {
  }

  loadExecutors(): Observable<Executor[]> {
    return this.apiService.get<Executor[]>('/executor').pipe(
      map(response => response.data),
      map(items => this.apiService.naturalSort(items, 'header')),
    );
  }
}
